import { type QueryKey } from 'react-query';

export const getAnalyticalSplitStatusQueryKey = (
  companyId: string,
): QueryKey => {
  return ['GET /bookkeeping/analytical-split-status', companyId];
};

export const getBookkeepingSettingsQueryKey = (companyId: string): QueryKey => {
  return ['useBookkeepingSettings', companyId];
};

export const getSpanishDprSettingsQueryKey = (companyId: string): QueryKey => {
  return ['useSpanishDprSettings', companyId];
};

export const getSpainClosurePeriodsQueryKey = (
  companyId: string,
  query?: { state?: string; limit?: number },
): QueryKey => {
  return ['useSpainClosurePeriods', companyId, query];
};
